import React from 'react'

import { Grid, Container, Card } from 'semantic-ui-react'

import { themes } from '@/theme/context'
import { FullWidthBackgroundContainer, ThemedText, BodyContainer, CustomImage, LinkCard } from './style'
import { WinnersLayout } from '@/components/Winners/WinnersLayout'
import { FlexBlock, Link } from '@/components/OtherCustomComponents/style'

export const BodyComponent = (props) => {
    return (<BodyContainer>
        <FullWidthBackgroundContainer>
            <Container>
                <Card.Group itemsPerRow={3} stackable>
                    <LinkCard href="/node/2874">
                        <Card.Content textAlign="center">
                            <CustomImage src="/themes/olymp/images/olymp3.svg" centered size="tiny" $margin="0 0 .5em 0"/><br />
                            <b>Открытые международные студенческие интернет-олимпиады (ВО)</b>
                        </Card.Content>
                    </LinkCard>
                    <LinkCard href="/node/2877">
                        <Card.Content textAlign="center">
                            <CustomImage src="/themes/olymp/images/olymp1.svg" centered $height="67px" $margin="0 0 .2em 0" /><br />
                            <b>Междисциплинарная интернет-олимпиада инновационного характера</b>
                        </Card.Content>
                    </LinkCard>
                    <LinkCard href="/node/2876">
                        <Card.Content textAlign="center">
                            <CustomImage src="/themes/olymp/images/olymp2.svg" centered size="tiny" $margin="0 0 .5em 0" /><br />
                            <b>Открытые международные студенческие интернет-олимпиады (СПО)</b>
                        </Card.Content>
                    </LinkCard>
                </Card.Group>
            </Container>
        </FullWidthBackgroundContainer>
        <Container>
            <WinnersLayout {...props}>
                <ThemedText><b>Галерея победителей 2024–2025 учебного года</b></ThemedText>
            </WinnersLayout>
        </Container>
        <FullWidthBackgroundContainer>
            <Container>
                <p><ThemedText><b>Преимущества</b></ThemedText></p>
                <Grid stackable>
                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <FlexBlock className='streamlined'>
                                <CustomImage src="/themes/olymp/images/medal_kubok_io.svg" size="tiny" $margin="5px .8em auto 0" />
                                <div>Предоставление медалей и дипломов победителям заключительных и очных финальных туров</div>
                            </FlexBlock>
                        </Grid.Column>
                        <Grid.Column>
                            <FlexBlock className='streamlined'>
                                <CustomImage src="/themes/olymp/images/reiting_IO.svg" size="tiny" $margin="5px .8em auto 0" />
                                <div>Позиция в&nbsp;перечне рассматриваемых состязаний при&nbsp;расчете критерия «Количество призеров студенческих олимпиад» в&nbsp;рейтинге лучших вузов России RAEX</div>
                            </FlexBlock>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <FlexBlock className='streamlined'>
                                <CustomImage src="/themes/olymp/images/diplom_blagpismo_io.svg" size="tiny" $margin="5px .8em auto 0" />
                                <div>Формирование электронных сертификатов всем участникам заключительных и очных финальных туров, благодарственных писем организаторам олимпиад в&nbsp;вузе/ссузе</div>
                            </FlexBlock>
                        </Grid.Column>
                        <Grid.Column>
                            <FlexBlock className='streamlined'>
                                <CustomImage src="/themes/olymp/images/kurs_IO.svg" size="tiny" $margin="5px .8em auto 0" />
                                <div>
                                    Проведение курсов повышения квалификации для руководителей команд в&nbsp;рамках очных туров интернет-олимпиад.
                                </div>
                            </FlexBlock>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </FullWidthBackgroundContainer>
    </BodyContainer>)
}
